/*
  VAIROK · ficha VK-Q5 (bloques «vk_buy» y «vk_after»). Sin dependencias.
  1. Selector de 1 o 2 luces: copia la cantidad en un input oculto name="quantity" del formulario de serie
     (product.js envía el FormData del formulario a cart_add_url y abre el cajón) y cambia la línea del total.
     No es una variante: n8n calcula PAGAT por SKU × cantidad.
  2. Alto de la foto en el carrusel (< 900 px) para que el botón entre en la primera pantalla, también a 390 × 664.
  3. (Sin efecto desde el 04/10/2026: la galería ya no tiene miniaturas; ver vk-pdp-gallery.js.)
  4. Globo del chat (Shopify Inbox) oculto mientras se ve la zona de compra.
  El JS que abre una pregunta de la FAQ por ancla es del paquete de secciones.
*/
(function () {
  'use strict';
  if (window.__vkPdpInit) return;
  window.__vkPdpInit = true;

  var MOBILE_MAX = 899; // carrusel de vk-pdp-gallery.css

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 1. Cantidad (1 o 2 luces) ---------- */
  function findForm(wrap) {
    var id = wrap && wrap.getAttribute('data-form-id');
    var form = id ? document.getElementById(id) : null;
    if (!form) form = document.querySelector(".thb-product-detail form[data-type='add-to-cart-form']");
    return form;
  }

  function ensureQuantityInput(form) {
    var input = null;
    var all = form.querySelectorAll('[name="quantity"]');
    if (all.length) input = all[0];
    if (!input && form.id) input = document.querySelector('[name="quantity"][form="' + form.id + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      form.appendChild(input);
    }
    return input;
  }

  function initQuantity() {
    var wrap = document.querySelector('[data-vk-qty]');
    if (!wrap) return;
    var radios = wrap.querySelectorAll('input[name="vk-qty"]');
    var total = document.querySelector('.vk-buy .vk-total');

    function apply(radio) {
      var qty = radio.value === '2' ? '2' : '1';
      var form = findForm(wrap);
      if (form) ensureQuantityInput(form).value = qty;
      if (total) {
        var html = total.getAttribute('data-vk-total-' + qty);
        if (html !== null && total.innerHTML !== html) total.innerHTML = html;
      }
      Array.prototype.forEach.call(radios, function (r) {
        var label = r.closest('.vk-opt');
        if (label) label.classList.toggle('is-checked', r.checked);
      });
      document.dispatchEvent(new CustomEvent('vk:qty-change', { detail: { quantity: parseInt(qty, 10) } }));
    }

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r); });
    });
    var checked = wrap.querySelector('input[name="vk-qty"]:checked') || radios[0];
    if (checked) apply(checked);
  }

  /* ---------- 2. Alto de la foto en móvil ---------- */
  var probe = null;
  function viewportHeight() {
    // 100svh: alto con las barras del navegador visibles (no salta al hacer scroll). Si no lo admite, innerHeight.
    if (window.CSS && CSS.supports && CSS.supports('height', '100svh')) {
      if (!probe) {
        probe = document.createElement('div');
        probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100svh;visibility:hidden;pointer-events:none;';
        document.body.appendChild(probe);
      }
      var h = probe.offsetHeight;
      if (h > 0) return h;
    }
    return window.innerHeight;
  }

  function headerHeight() {
    var header = document.querySelector('.header-section') || document.querySelector('theme-header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    // Alto visible de la cabecera en su sitio (sin contar lo que ya se haya desplazado).
    return Math.max(0, rect.height);
  }

  var fitQueued = false;
  function fit() {
    fitQueued = false;
    var detail = document.querySelector('.thb-product-detail');
    if (!detail) return;
    if (window.innerWidth > MOBILE_MAX) {
      if (detail.style.getPropertyValue('--vk-slide-h')) {
        detail.style.removeProperty('--vk-slide-h');
        resizeSlider();
      }
      return;
    }
    var gallery = detail.querySelector('[id^="MediaGallery-"]');
    var thumbs = detail.querySelector('.product-thumbnail-container');
    var button = detail.querySelector('.product-information .single-add-to-cart-button');
    if (!gallery || !button) return;

    var vh = viewportHeight();
    // Espacio por encima de la foto: cabecera visible y, si lo hay, lo que vaya antes (migas de pan).
    var galleryTop = gallery.getBoundingClientRect().top + window.pageYOffset;
    var above = Math.max(headerHeight(), galleryTop);
    // Desde el borde superior de las miniaturas hasta el borde inferior del botón (no depende del alto de la foto).
    var startEl = thumbs && thumbs.offsetParent !== null ? thumbs : detail.querySelector('.product-information');
    var block = button.getBoundingClientRect().bottom - startEl.getBoundingClientRect().top;
    if (!(block > 0)) return;

    var maxH = gallery.clientWidth || document.documentElement.clientWidth;
    var h = Math.round(vh - above - block - 16);
    h = Math.max(190, Math.min(h, maxH));
    var current = parseFloat(detail.style.getPropertyValue('--vk-slide-h')) || 0;
    if (Math.abs(current - h) < 1) return;
    detail.style.setProperty('--vk-slide-h', h + 'px');
    resizeSlider();
  }

  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    window.requestAnimationFrame(fit);
  }

  function slider() {
    return document.querySelector('product-slider-thumbnails');
  }

  function resizeSlider() {
    var s = slider();
    if (s && s.flkty && typeof s.flkty.resize === 'function') s.flkty.resize();
  }

  function initFit() {
    queueFit();
    window.addEventListener('resize', queueFit, { passive: true });
    window.addEventListener('orientationchange', queueFit, { passive: true });
    window.addEventListener('load', queueFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueFit);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(queueFit);
      var info = document.querySelector('.thb-product-detail .product-information');
      var thumbs = document.querySelector('.thb-product-detail .product-thumbnail-container');
      var header = document.querySelector('.header-section');
      if (info) ro.observe(info);
      if (thumbs) ro.observe(thumbs);
      if (header) ro.observe(header);
    }
  }

  /* ---------- 3. Miniaturas: la inicial y el teclado ---------- */
  function syncThumbs(s) {
    var container = document.querySelector('.thb-product-detail .product-thumbnail-container');
    if (!container || !s) return;
    var thumbs = container.querySelectorAll('.product-thumbnail');
    var selected = null;
    if (s.flkty && s.flkty.selectedElement) {
      selected = document.getElementById(s.flkty.selectedElement.id.replace('Slide-', 'Thumb-'));
    }
    if (!selected && s.hasAttribute('data-vk-media-order')) selected = thumbs[0];
    Array.prototype.forEach.call(thumbs, function (t) {
      var on = t === selected;
      if (selected) t.classList.toggle('is-initial-selected', on);
      if (on) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  }

  function initThumbs() {
    var container = document.querySelector('.thb-product-detail .product-thumbnail-container');
    if (!container) return;
    Array.prototype.forEach.call(container.querySelectorAll('.product-thumbnail'), function (t) {
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '0');
      if (!t.hasAttribute('role')) t.setAttribute('role', 'button');
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          t.click();
        }
      });
    });

    function hook() {
      var s = slider();
      if (!s || !s.flkty) return false;
      syncThumbs(s);
      s.flkty.on('change', function () { syncThumbs(s); });
      resizeSlider();
      queueFit();
      return true;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('product-slider-thumbnails').then(function () {
        window.requestAnimationFrame(function () {
          if (!hook()) window.setTimeout(hook, 300);
        });
      });
    } else {
      window.setTimeout(hook, 500);
    }
  }

  /* ---------- 4. Chat de Shopify Inbox: fuera mientras se ve la zona de compra ---------- */
  // El globo del chat tapaba la opción «2 Lichter» (y en escritorio parte de las ventajas). Sin tocar la app:
  // body.vk-chat-wait (vk-pdp.css) lo oculta hasta que el botón de compra queda por encima de la pantalla.
  function initChatWait() {
    var button = document.querySelector('.thb-product-detail .product-information .single-add-to-cart-button');
    if (!button || !('IntersectionObserver' in window)) return;
    document.body.classList.add('vk-chat-wait');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        document.body.classList.toggle('vk-chat-wait', !passed);
      });
    }).observe(button);
  }

  ready(function () {
    if (!document.body || !document.body.classList.contains('template-product-vk-q5')) {
      // Solo en la ficha VK-Q5; en el editor del tema se permite para poder previsualizar.
      if (!(window.Shopify && window.Shopify.designMode)) return;
    }
    initQuantity();
    initFit();
    initThumbs();
    initChatWait();
  });

  // Editor del tema: al recargar la sección, volver a enlazar.
  document.addEventListener('shopify:section:load', function () {
    initQuantity();
    initThumbs();
    queueFit();
  });
})();
